export default "__VITE_ASSET__bbb2a1ea__"